import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'vuex'
import {publicRoutes} from './public'
import {main} from './private/testindex'
import CorePage from "~/pages/CorePage";
import auth from "~/router/middleware/auth";
import Router from "~/utils/Router";
import Meta from "~/utils/RouterMeta";
import {authService} from "~/services/AuthService";

const routes = [
    Router.instance({
        path: '/',
        component: CorePage,
        redirect: {name: 'orders'},
        meta: Meta.instance({
            middleware: auth,
            title: 'Главная'
        }),
        children: [...main]
    }),
    {
        path: '/logout',
        name: 'logout',
        meta: {title: 'Авторизация'},
        async beforeEnter(to, from, next) {
            await authService.logout()
            await router.push({name: 'auth'})
        }
    }
].concat(publicRoutes)

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes,
})

const func = (to) => {
    const has = to.matched
        .find(match => typeof (match.meta.middleware) === 'function')
    return has?.meta?.middleware
}

router.beforeEach((to, from, next) => {
    const middleware = func(to)
    document.title = to.meta.title || 'Главная'
    if (middleware) {
        return middleware(to, next, store)
    }
    return next()
})

export default router
